import {FormControl, FormHelperText, InputLabel} from "@material-ui/core";
import React, {cloneElement} from "react";
import {RenderIf} from "../common/render-if/RenderIf";
import {useRegistrationStyles} from "./registrationStyles";

export const FormControlContainer = (props:{
    children:JSX.Element;
    label:string;
    hasError:()=>boolean|undefined;
    errorMessage?:string;
    id:string;
})=>{
    let classes = useRegistrationStyles();
    let {hasError,errorMessage,label,id} = props;
    let helperText = `${id}-helper-text`;

    return (
        <FormControl error={!!hasError()} className={classes.formControl}>
            <RenderIf if={!!label}>
                <InputLabel className="label" required shrink htmlFor={id}>
                    {label}
                </InputLabel>
            </RenderIf>
            {cloneElement(props.children,{id})}
            <RenderIf if={!!hasError()}>
                <FormHelperText id={helperText}>{errorMessage||'Required'}</FormHelperText>
            </RenderIf>

        </FormControl>
    );
};
